<div class="verification"
  [class.verification--failed]="!passed"
  [class.verification--passed]="passed">
  <app-icon class="verification-ico" file="status" [icon]="passed ? 'passed' : 'failed'"></app-icon>
</div>
